import initStore from './initStore';
import thunks from './thunks';
import actions from './actions';

import { ICommunityEngagementModel } from './types';

const communityEngagement: ICommunityEngagementModel = {
  ...initStore,
  ...thunks,
  ...actions,
};

export default communityEngagement;
